import { useEffect } from 'react';

/**
 *  Hook to call key presses, made as generic as possible for reuse
 */
export function useKeyPress(key, callback) {
  var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  /**
   * attaches event listener on mount and removes it when the component unmounts
   */
  useEffect(function () {
    /**
     * function to call when user interacts with the keyboard
     */
    var handleKeyPress = function handleKeyPress(event) {
      if (active && event.key === key) callback(event);
    };
    document.addEventListener('keydown', handleKeyPress);
    return function () {
      return document.removeEventListener('keydown', handleKeyPress);
    };
  }, [active, callback, key]);
}